import { CommonResponseModel } from "../../../../Models/tableDetailsModel";
import agentsApi from "../../agents.api";
import {
    AvailableProductsAndCommissionsResponse,
    AvailableUserTypesResponse,
    GenericResponseV2,
    ICreateDownlineRequest,
} from "./createDownline.models";

export const GetAvailableProductsAndCommissions = async (parentUserId: number) => {
    const response: CommonResponseModel<AvailableProductsAndCommissionsResponse[]> =
        await agentsApi.GetAvailableProductsAndCommissions.get(parentUserId);
    return response;
};

export const GetAvailableUserTypes = async (userId: number) => {
    const response: CommonResponseModel<AvailableUserTypesResponse[]> =
        await agentsApi.GetAvailableUserTypes.get(userId);
    return response;
};

export const CreateDownline = async (payload: ICreateDownlineRequest) => {
    const response: GenericResponseV2<string> = await agentsApi.CreateDownline.post(payload);
    return response;
};
